import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientRepresentativeSaveCitizenshipsMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { SaveCitizenshipParam } from 'api/types/params';

import { parseLegalClientRepresentative } from './helpers';

export const useLegalClientRepresentativeSaveCitizenships = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientRepresentativeSaveCitizenshipsMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientRepresentativeSaveCitizenships
      ? parseLegalClientRepresentative(
          data.legalClientRepresentativeSaveCitizenships
        )
      : undefined,
    loading,
    error,
    saveCitizenships: useCallback(
      async (id: string, params: SaveCitizenshipParam) => {
        const res = await handle({
          variables: {
            id,
            input: params,
          },
        });
        return res?.data?.legalClientRepresentativeSaveCitizenships
          ? parseLegalClientRepresentative(
              res.data.legalClientRepresentativeSaveCitizenships
            )
          : undefined;
      },
      [handle]
    ),
  };
};
